import React from "react";
import {
  Box,
  Container,
  Typography,
  useTheme,
  //useMediaQuery,
} from "@mui/material";
import { Parceiros } from "../../data";

export default function PartnersComponent() {
  const theme = useTheme();
  //const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Box
      sx={{
        py: { xs: 6, md: 10 },
        backgroundColor: theme.palette.background.paper,
        position: "relative",
      }}
    >
      <Container maxWidth="lg">
        {/* Header Section */}
        <Box sx={{ textAlign: "center", mb: { xs: 6, md: 8 } }}>
          <Typography
            variant="h3"
            component="h1"
            gutterBottom
            sx={{
              fontWeight: "bold",
              color: theme.palette.primary.main,
              fontSize: { xs: "2rem", md: "2.5rem" },
            }}
          >
            Nossos Parceiros
          </Typography>
          <Typography
            variant="h6"
            sx={{
              color: theme.palette.text.secondary,
              maxWidth: "600px",
              mx: "auto",
              lineHeight: 1.6,
            }}
          >
            Colaboramos com empresas líderes para garantir excelência em todos os nossos serviços
          </Typography>
        </Box>

        {/* Partners Carousel Style */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "center",
            gap: { xs: 3, md: 4 },
            perspective: "1000px",
          }}
        >
          {Parceiros.map((parceiro, index) => (
            <Box
              key={parceiro.id}
              sx={{
                flex: "0 0 auto",
                width: { 
                  xs: "calc(50% - 12px)", 
                  sm: "calc(33.333% - 16px)", 
                  md: "calc(25% - 16px)",
                  lg: "calc(20% - 16px)" 
                },
                maxWidth: "200px",
                minHeight: "120px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: 3,
                backgroundColor: "white",
                borderRadius: 2,
                boxShadow: theme.shadows[2],
                border: `1px solid ${theme.palette.divider}`,
                transition: "all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
                cursor: "pointer",
                position: "relative",
                overflow: "hidden",
                "&::before": {
                  content: '""',
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  background: `linear-gradient(135deg, ${theme.palette.primary.main}10, ${theme.palette.secondary.main}10)`,
                  opacity: 0,
                  transition: "opacity 0.3s ease",
                },
                "&:hover": {
                  transform: "translateY(-8px) scale(1.05)",
                  boxShadow: theme.shadows[8],
                  borderColor: theme.palette.primary.light,
                  "&::before": {
                    opacity: 1,
                  },
                },
              }}
            >
              <Box
                component="img"
                src={parceiro.image}
                alt={parceiro.name}
                sx={{
                  maxWidth: "100%",
                  maxHeight: "60px",
                  width: "auto",
                  height: "auto",
                  objectFit: "contain",
                  transition: "all 0.3s ease",
                  filter: "grayscale(30%) brightness(0.9)",
                  "&:hover": {
                    filter: "grayscale(0%) brightness(1)",
                    transform: "scale(1.1)",
                  },
                }}
              />
              
              {/* Partner Name Tooltip */}
              <Box
                sx={{
                  position: "absolute",
                  bottom: 8,
                  left: "50%",
                  transform: "translateX(-50%)",
                  backgroundColor: theme.palette.primary.main,
                  color: "white",
                  padding: "2px 8px",
                  borderRadius: 1,
                  fontSize: "0.7rem",
                  fontWeight: "medium",
                  opacity: 0,
                  transition: "all 0.3s ease",
                  pointerEvents: "none",
                }}
                className="partner-tooltip"
              >
                {parceiro.name}
              </Box>
            </Box>
          ))}
        </Box>

        {/* CTA Section */}
        <Box sx={{ textAlign: "center", mt: 8 }}>
          <Typography
            variant="body1"
            sx={{
              color: theme.palette.text.secondary,
              mb: 2,
              fontStyle: "italic",
            }}
          >
            Junte-se ao nosso ecossistema de parcerias
          </Typography>
          <Box
            sx={{
              display: "inline-flex",
              alignItems: "center",
              gap: 1,
              padding: "8px 16px",
              backgroundColor: theme.palette.primary.light,
              color: theme.palette.primary.contrastText,
              borderRadius: 2,
              fontSize: "0.9rem",
              fontWeight: "medium",
            }}
          >
            <Box
              component="span"
              sx={{
                width: 6,
                height: 6,
                backgroundColor: theme.palette.success.main,
                borderRadius: "50%",
              }}
            />
            Parcerias estratégicas desde 2018
          </Box>
        </Box>
      </Container>
    </Box>
  );
}